export default __webpack_public_path__ + "static/img5-c62188be1eed6ad6f4be429cee5df82a.png";